import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InstructionForm } from "web_myplann/Portfolio/Forms/ToolsShared/InstructionForm";
import type { InstructionTypeLabels } from "web_myplann/Portfolio/Forms/ToolsShared/useInstructionOptions";
import { MyPlannDrawer } from "web_myplann/Shared/Components/MyPlannDrawer";
import type { z } from "zod";

type Props<TSchema extends z.ZodTypeAny> = {
	open: boolean;
	onClose: () => void;
	schema: TSchema;
	defaultValues: z.input<TSchema>;
	onSave: (values: z.input<TSchema>) => void;
	isNew: boolean;
	typeLabels?: InstructionTypeLabels;
	showCount?: boolean;
	onRemove?: () => void;
};

export const InstructionDrawer = <TSchema extends z.ZodTypeAny>({
	open,
	onClose,
	schema,
	defaultValues,
	onSave,
	isNew,
	typeLabels,
	showCount,
	onRemove,
}: Props<TSchema>) => {
	const { t } = useResource();

	const saveInstruction = (values: z.input<TSchema>) => {
		onSave(values);
		onClose();
	};

	return (
		<MyPlannDrawer
			anchor="bottom"
			open={open}
			onClose={onClose}
			title={t(Resources.Portfolio.AddTools.Drawers.instruction)}
			grabber
		>
			<InstructionForm
				schema={schema}
				defaultValues={defaultValues}
				typeLabels={typeLabels}
				showCount={showCount}
				onSave={saveInstruction}
				isNew={isNew}
				onCancel={onClose}
				onRemove={onRemove}
			/>
		</MyPlannDrawer>
	);
};
